const loc_pl_strings = {
    "Login": {
        "HEADING": "Zaloguj się na platformę FOLBB-ID",
        "LOGIN": "Zaloguj się",
        "USER": "Użytkownik",
        "PASSWORD": "Hasło",
        "LOGIN_FAIL": "Logowanie nieudane",
        "LOGIN_FIELD_REQUIRED": "Pole „nazwa użytkownika” jest wymagane",
        "PASSWORD_FIELD_REQUIRED": "Pole „hasło” jest wymagane",
        "FORGOT_PASSWORD": "Zapomniane hasło?",
        "DIFFERENT_ACCOUNT": "Zaloguj się na inne konto",
        "NO_ACCOUNT": "Nie posiadasz konta? ",
        "REGISTER": "Zarejestruj się w FOLBB digital",
        "CHANGE_DENIED_TEXT": "Skorzystaj np. z OWA do zmiany hasła AD lub skontaktuj się z działem obsługi."
    },
    "Dashboard": {
        "DASHBOARD_TEXT": "Panel użytkownika",
        "ACTION_TEXT": "Akcje",
        "CHANGE_PASSWORD_TEXT": "Zmień hasło",
        "MY_APPLICATIONS_TEXT": "Moje aplikacje FOLBB",
        "APPLICATIONS_TEXT": "Aplikacje FOLBB",
        "USERS_LIST_TEXT": "Zarządzanie użytkownikami"
    },
    "DashboardHome": {
        "ACTION_TEXT": "Panel użytkownika",
        "MY_APPLICATIONS_TEXT": "Moje aplikacje FOLBB",
        "APPLICATIONS_TEXT": "Aplikacje FOLBB"
    },
    "Header": {
        "USER_MENU_TEXT": "Menu użytkownika",
        "ACTION_TEXT": "Akcje",
        "CHANGE_PASSWORD_TEXT": "Zmień hasło",
        "USERS_LIST_TEXT": "Zarządzanie użytkownikami",
        "USER_GROUPS": "Role"
    },
    "Credentials": {
        "OLD_PASSWORD": "Stare hasło",
        "NEW_PASSWORD": "Nowe hasło",
        "CONFIRM_PASSWORD": "Potwierdź hasło",
        "PASS_DO_NOT_MATCH": " Hasła nie są zgodne",
        "PASSWORD_FIELD_REQUIRED": "Pole „hasło” jest wymagane",
        "OLD_PASSWORD_FIELD_REQUIRED": "Pole „stare hasło” jest wymagane",
        "SUCCESS_TEXT": "Hasło zostało zmienione",
        "HEADING": "Zmień dane FOLBB-ID",
        "HELP": "Potrzebujesz pomocy?",
        "SAVE": "Zmień",
        "CANCEL": "Anuluj",
        "PASSWORD_CHANGE_ERROR": "Nie można było zapisać danych. Spróbuj ponownie później",
        "PASSWORD_STREIGHT_ERROR": "Hasło powinno zawierać minimum 10 znaków, w tym małe i wielkie litery, znaki specjalne i cyfry",
        "PASSWORD_REQUIREMENTS_TEXT": "Hasło musi spełniać następujące wymagania i zawierać:",
        "LOWERCASE_LETTER_TEXT": "Co najmniej jedną literę ",
        "UPPERCASE_LETTER_TEXT": "Co najmniej jedną wielką literę",
        "NUMBER_TEXT": "Co najmniej jedną cyfrę",
        "SPECIAL_SYMBOL_TEXT": "Co najmniej jeden znak specjalny",
        "PASSWORD_LENGTH_TEXT": "Co najmniej 10 znaków",
        "PASSWORD_RESTRICTION_TEXT": "Imię, nazwisko lub nazwa użytkownika nie mogą występować w haśle",
        "CHANGE_PASSWORD_TEXT": "Zmień hasło",
        "ACTION_TEXT": "Działania",
        "CHANGE_DENIED_TEXT": "Skorzystaj np. z OWA do zmiany hasła AD lub skontaktuj się z działem obsługi."
    },
    "CreatePassword": {
        "PASSWORD": "Utwórz hasło",
        "CONFIRM_PASSWORD": "Potwierdź hasło",
        "PASS_DO_NOT_MATCH": "Hasła nie są zgodne",
        "PASSWORD_FIELD_REQUIRED": "Pole „hasło” jest wymagane",
        "SUCCESS_TEXT": "Dane zostały zapisane",
        "HEADING": "Utwórz hasło",
        "HELP": "Potrzebujesz pomocy?",
        "SAVE": "Zmień",
        "CANCEL": "Anuluj",
        "PASSWORD_CHANGE_ERROR": "Nie można było zapisać danych. Spróbuj ponownie później",
        "PASSWORD_STREIGHT_ERROR": "Hasło powinno zawierać minimum 10 znaków, w tym małe i wielkie litery, znaki specjalne i cyfry",
        "PASSWORD_REQUIREMENTS_TEXT": "Hasło musi spełniać następujące wymagania i zawierać:",
        "LOWERCASE_LETTER_TEXT": "Co najmniej jedną literę",
        "UPPERCASE_LETTER_TEXT": "Co najmniej jedną wielką literę",
        "NUMBER_TEXT": "Co najmniej jedną cyfrę",
        "SPECIAL_SYMBOL_TEXT": "Co najmniej jeden znak specjalny",
        "PASSWORD_LENGTH_TEXT": "Co najmniej 10 znaków",
        "PASSWORD_RESTRICTION_TEXT": "Imię, nazwisko lub nazwa użytkownika nie mogą występować w haśle",
        "PASSWORD_WAS_SET": "Odnośnik został już wykorzystany do ustanowienia hasła. Jeśli nie pamiętasz hasła, skorzystaj z funkcji resetowania hasła.",
        "OLD_PASSWORD_REQUIRED": "Pole „stare hasło” jest wymagane",
        "MMID_CHANGE_PASSWORD": "Zmień hasło",
        "OLD_PASSWORD": "Stare hasło",
        "INVALID_OLD_PASSWORD": "Nieprawidłowe stare hasło",
        "USER_NOT_FOUND_OR_INACTIVE": "Użytkownik nie został znaleziony lub nie jest aktywny",
        "UNKNOWN_ERROR": "Coś poszło nie tak przy zmianie hasła."
    },
    "ForgotPassword": {
        "USER": "E-mail",
        "LOGIN_FAIL": "Wprowadź prawidłowy adres e-mail",
        "LOGIN_FIELD_REQUIRED": "Pole „adres e-mail” jest wymagane",
        "HEADING": "Zapomniane hasło",
        "HELP": "Potrzebujesz pomocy?",
        "SAVE": "Wyślij wiadomość e-mail do zresetowania hasła",
        "CANCEL": "Anuluj",
        "SUCCESS_TEXT": "Sprawdź, czy wiadomość e-mail dotarła do Twojej skrzynki.",
        "CHANGE_DENIED_TEXT": "Skorzystaj np. z OWA do zmiany hasła AD lub skontaktuj się z działem obsługi.",
        "PASSWORD_RESET_TOO_OFTEN": "Zbyt wiele prób użycia funkcji resetowania hasła. Spróbuj ponownie później",
        "RESET_FAILED": "Logowanie nieudane",
        "LINK_EXPIRED": "Twój link do logowania wygasł. Wpisz swój adres e-mail, aby uzyskać nowy link do logowania.",
        "HEADING_EXPIRED": "Twój link do logowania wygasł",
        "SAVE_EXPIRED": "Uzyskaj nowy link do logowania"
    },
    "UsersList": {
        "USERS_LIST_TEXT": "Zarządzanie użytkownikami",
        "ACTIVE": "Aktywne",
        "INACTIVE": "Nieaktywne",
        "MMID": "Identyfikator FOLBB",
        "OU": "Jednostka organizacyjna",
        "ORGANIZATION_UNIT": "Jednostka organizacyjna",
        "LANGUAGE": "Język",
        "OPEN_FILTER": "Otwórz filtr",
        "CLOSE_FILTER": "Zamknij filtr",
        "RESET": "Zresetuj",
        "RESET_ALL_FILTERS": "Zresetuj wszystkie filtry",
        "SEARCH": "Szukaj",
        "STATUS": "Status",
        "GROUPS": "Grupy",
        "SHOW_ALL_DETAILS": "Wyświetl wszystkie szczegóły",
        "SHOW_LESS": "Wyświetl mniej",
        "ASCENDING": "Rosnąco",
        "DESCENDING": "Malejąco",
        "LIST_END": "Koniec listy",
        "SORT_BY_LASTNAME": "Sortuj wg nazwiska",
        "SORT_BY_FIRSTNAME": "Sortuj wg imienia",
        "SORT_BY_EMAIL": "Sortuj wg adresu e-mail",
        "SORT_BY_LANGUAGE": "Sortuj wg preferowanego języka",
        "SORT_BY_STATUS": "Sortuj wg statusu",
        "SORT_BY_OU": "Sortuj wg jedn. org.",
        "EDIT": "Edytuj",
        "CREATE": "Nowy użytkownik",
        "DIGICREATE": "Nowy użytkownik FOLBB digital",
        "ACTIVATE": "Aktywuj",
        "DEACTIVATE": "Dezaktywuj",
        "USER_WAS_ACTIVATED": "Użytkownik został aktywowany",
        "USER_WAS_DEACTIVATED": "Użytkownik został zdezaktywowany",
        "ERROR_USER_ACTIVATION": "Błąd podczas aktywacji użytkownika",
        "ERROR_USER_DEACTIVATION": "Błąd podczas dezaktywacji użytkownika",
        "SEND_FORGOT_PW_EMAIL": "Wyślij wiadomość e-mail z przypomnieniem hasła",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Ogólna wiadomość e-mail z przypomnieniem hasła",
        "SEND_FORGOT_PW_EMAIL_DIGI": "Wiadomość e-mail z przypomnieniem hasła FOLBB digital",
        "COMPANY": "Firma",
        "SEND_WELCOME_EMAIL": "Wyślij powitalną wiadomość e-mail",
        "SEND_WELCOME_EMAIL_DIGI": "Powitalna wiadomość e-mail FOLBB digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "Powitalna wiadomość e-mail FOLBB digital bez przycisku hasła",
        "APPLY_FILTER_FOR_USERS": "Użyj filtrów lub funkcji wyszukiwania, aby wyświetlić wyniki",
        "GENERATING_EMAIL": "Generowanie wiadomości e-mail....",
        "ERROR_EMAIL_GENERATE": "Błąd generowania wiadomości e-mail....",
        "SORT_BY_ACCOUNT_NAME": "Sortuj wg nazwy logowania",
        "LOCKED": "Zablokowane",
        "UNLOCK": "Odblokuj",
        "SET_PASSWORD": "Ustaw hasło",
        "PHYSICAL_LOCATION": "Lokalizacja",
        "REQUIRED": "Wymagane",
        "USER_TYPE": "Typ użytkownika",
        "CANONICAL_NAME": "Nazwa kanoniczna"
    },
    "EditUser": {
        "USERS_LIST_TEXT": "Zarządzanie użytkownikami",
        "USER_WAS_ACTIVATED": "Użytkownik został aktywowany",
        "USER_WAS_DEACTIVATED": "Użytkownik został zdezaktywowany",
        "ERROR_USER_ACTIVATION": "Błąd podczas aktywacji użytkownika",
        "ERROR_USER_DEACTIVATION": "Błąd podczas dezaktywacji użytkownika",
        "LOADING_USER_ERROR": "Błąd wczytywania użytkownika",
        "FIRSTNAME": "Imię",
        "LASTNAME": "Nazwisko",
        "EMAIL": "E-mail",
        "ACCOUNT_NAME": "Nazwa logowania użytkownika (przed Windows 2000)",
        "LANGUAGE": "Język",
        "PRINCIPAL_NAME": "Główna nazwa użytkownika",
        "OU": "Jednostka organizacyjna",
        "CLASS_DISPLAY_NAME": "Nazwa wyświetlana",
        "PHONE": "Nr telefonu",
        "WEBSITE": "Strona Internetowa",
        "COUNTRY": "Kraj",
        "STATE": "Województwo",
        "LOCATION": "Miasto",
        "STREET": "Ulica",
        "POSTAL_CODE": "Kod pocztowy",
        "COMPANY": "Firma",
        "DEPARTMENT": "Dział",
        "PERSONAL_TITLE": "Tytuł",
        "MANAGER": "Menedżer",
        "DESCRIPTION": "Opis",
        "GROUPS": "Grupy",
        "SAVE": "Zapisz",
        "CANCEL": "Anuluj",
        "USER_STATUS": "Status użytkownika",
        "ACTIVE": "Aktywne",
        "INACTIVE": "Nieaktywne",
        "ACTIVATE": "Aktywuj",
        "DEACTIVATE": "Dezaktywuj",
        "USER_WAS_SAVED": "Użytkownik został zapisany. Zaktualizowanie informacji na serwerze może zająć do 60 sekund.<br/> Jeśli dane nie zostaną zaktualizowane, spróbuj odświeżyć stronę w 30 sekundowych odstępach.",
        "UNKNOWN_ERROR": "Podczas zapisywania użytkownika wystąpił nieznany błąd",
        "PROXY_ADDRESSES": "Adresy proxy",
        "BROWSE": "Przeglądaj",
        "REMOVE": "Usuń",
        "ONLY_JPG": "Dozwolone są wyłącznie obrazy w formacie JPG!",
        "FILE_SIZE": "Rozmiar pliku nie może przekraczać 100 KB!",
        "DIMENSIONS": "Maksymalne wymiary obrazu wynoszą 96x96 pikseli!",
        "SEND_FORGOT_PW_EMAIL": "Wyślij wiadomość e-mail z przypomnieniem hasła",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Ogólna wiadomość e-mail z przypomnieniem hasła",
        "SEND_FORGOT_PW_EMAIL_DIGI": "Wiadomość e-mail z przypomnieniem hasła FOLBB digital",
        "VIRUS_FOUND": "Nie udało się zapisać użytkownika. W załączniku wykryto złośliwe oprogramowanie. Plik nie zostanie przesłany. Skontaktuj się z administratorem systemu.",
        "VIRUS_SCANNER_NOT_AVL": "Nie udało się przeskanować pliku na obecność złośliwego oprogramowania. Spróbuj ponownie później. Jeżeli problem nie ustąpi, skontaktuj się z administratorem systemu.",
        "INFO": "Informacja:",
        "SEND_WELCOME_EMAIL": "Wyślij powitalną wiadomość e-mail",
        "SEND_WELCOME_EMAIL_DIGI": "Powitalna wiadomość e-mail FOLBB digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "Powitalna wiadomość e-mail FOLBB digital bez przycisku hasła",
        "SAVING_USER_SPINNER": "Proszę czekać, trwa zapisywanie użytkownika...",
        "DUPLICATE_USER": "Użytkownik już istnieje",
        "GENERATING_EMAIL": "Generowanie wiadomości e-mail....",
        "ERROR_EMAIL_GENERATE": "Błąd generowania wiadomości e-mail....",
        "UNLOCK": "Odblokuj",
        "SET_PASSWORD": "Ustaw hasło",
        "COST_CENTER": "Centrum kosztów",
        "JOB_TITLE": "Tytuł zawodowy",
        "GENDER": "Płeć",
        "USER_NOT_FOUND": "Nie znaleziono użytkownika",
        "USER_TYPE": "Typ użytkownika",
        "CANONICAL_NAME": "Nazwa kanoniczna"
    },
    "Shared": {
        "USER_WAS_ACTIVATED": "Użytkownik został aktywowany",
        "USER_WAS_DEACTIVATED": "Użytkownik został zdezaktywowany",
        "ERROR_USER_ACTIVATION": "Błąd podczas aktywacji użytkownika",
        "ERROR_USER_DEACTIVATION": "Błąd podczas dezaktywacji użytkownika",
        "EMAIL_WAS_SENT": "Wiadomość e-mail została wysłana.",
        "EMAIL_NOT_SENT_USER_ACTIVE": "Wiadomość e-mail nie została wysłana. Użytkownik jest już aktywny. Użyj funkcji wysyłania wiadomości e-mail z przypomnieniem hasła",
        "ERROR_EMAIL_SEND": "Wystąpił błąd przy próbie wysłania wiadomości e-mail",
        "EMAIL_NOT_SENT_USER_INACTIVE": "Wiadomość e-mail nie została wysłana. Użytkownik jest nieaktywny. Użyj funkcji wysyłania zaproszenia do rejestracji w FOLBB digital.",
        "PASSWORD_RESET_TOO_OFTEN": "Zbyt wiele prób użycia funkcji resetowania hasła. Spróbuj ponownie później",
        "USER_WAS_UNLOCKED": "Użytkownik został odblokowany",
        "ERROR_UNLOCK_USER": "Błąd odblokowywania użytkownika"
    },
    "Backend": {
        "FieldRequired": "To pole jest wymagane.",
        "FirstName": "Imię",
        "InvalidEmail": "Wprowadź prawidłowy adres e-mail",
        "InvalidPhone": "Nieprawidłowy numer telefonu.",
        "LastName": "Nazwisko",
        "StringLength": "Pole musi mieć formę wiersza o minimalnej długości {2} i maksymalnej długości {1} znaków."
    },
    "Emails": {
        "Header": "Twoje konto {{var-app-name}}",
        "Welcome": "Witaj w {{var-app-name}}",
        "HelloLine": "Szanowny(-a) {{var-salutation}} {{var-first-name}} {{var-last-name}},",
        "AccountCreatedLine": "Twoje konto w {{var-app-name}} zostało utworzone. Aby ukończyć proces aktywacji konta, prosimy o zweryfikowanie adresu e-mail poprzez kliknięcie przycisku poniżej:",
        "Login": "Zaloguj się",
        "SingInLink": "W przyszłości możesz logować się przy pomocy tego linku:",
        "AccountDetails": "Dane Twojego konta:",
        "Email": "E-mail",
        "FristName": "Imię",
        "LastName": "Nazwisko",
        "BestRegards": "Z pozdrowieniami,<br/> Zespół {{var-app-name-2}}",
        "ForgotPassword": "Zapomniane hasło",
        "PleaseResetPassword": "Zresetuj swoje hasło w {{var-app-name}}",
        "ResetPasswordLine": "Możesz zresetować hasło do swojego konta {{var-app-name}} w ciągu najbliższych 24 godzin, klikając przycisk poniżej:",
        "ResetPassword": "Zresetuj hasło",
        "IgnoreEmailLine": "Jeśli nie chcesz resetować hasła, zwyczajnie zignoruj tę wiadomość.",
        "ResendWelcome1": "Ten link do logowania pozostanie ważny przez 5 dni:",
        "ResendWelcome2": "Uzyskaj ponownie link do logowania",
        "AccountCreatedLine_NoButton": "Twoje konto {{var-app-name}} zostało utworzone.",
        "CreateUserSubject": "Witaj w {{var-app-name}}",
        "ForgotPasswordSubject": "{{var-app-name}}: resetowanie hasła",
    },
    "ResendWelcome": {
        "GENERATING_EMAIL": "Generowanie powitalnej wiadomości e-mail...."
    }
};

export default loc_pl_strings;



// WEBPACK FOOTER //
// ./src/resources/pl.js